<template>
  <v-container class="featured-section light-background pt-7 pb-7">
    <v-layout align-center class="section-padding pb-7 clickable" @click="$router.push({ name: routeNames.upcomingEvents.name })">
      <div class="icon__background flex-none">
        <v-img v-if="iconURL" height="24" width="24" :src="iconURL" contain></v-img>
        <v-icon v-else color="primary lighten-1">{{ icon }}</v-icon>
      </div>
      <v-flex class="text-color__dark H3 px-2">{{title}}</v-flex>
      <v-chip v-if="!loading && !!upcomingEvents.length" small class="page-chip white" color="primary lighten-1">
        <div>{{ $t('activity_reservation.actions.see_all') }}</div>
        <v-icon small class="material-symbols-rounded ml-2">arrow_forward</v-icon>
      </v-chip>
    </v-layout>
    <div class="featured-page__container py-2">
      <v-layout v-if="loading" justify-center align-center>
        <v-progress-circular indeterminate />
      </v-layout>
      <upcoming-event-summary
        v-else
        v-for="(event, i) in upcomingEvents"
        :event="event"
        :key="i"
        class="ma-2"
      />
      <div v-if="!loading && !upcomingEvents.length" class="ml-10">
        <div class="H1 grey-1-b--text">{{ $t('upcoming_events.no_events_today') }}</div>
        <v-chip :to="{ name: routeNames.upcomingEvents.name }" class="light-background primary--text text--lighten-1 mt-3 interactive-chip">
          <span class="mr-2">{{ $t('upcoming_events.see_future_events') }}</span>
          <v-icon size="22" color="primary lighten-1 material-symbols-rounded">arrow_forward</v-icon>
        </v-chip>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { getTextValue } from '@/lib/helpers/LocalizedText'
import moment from 'moment'
import routeNames from '@/router/routes'

export default {
  props: {
    page: Object,
  },
  data () {
    return {
      loading: true,
      routeNames,
    }
  },
  computed: {
    ...mapState({
      upcomingEvents: state => state.pages.upcomingEvents,
    }),
    ...mapGetters({
      cardAppearance: 'service/getCardAppearance',
      authToken: 'auth/authToken',
    }),
    icon () {
      let icon = null
      if (this.page) {
        icon = this.page.icon
      }
      if (!icon) {
        icon = 'mdi-menu'
      }
      return icon
    },
    iconURL () {
      let icon = null
      if (this.page) {
        icon = this.page.iconUrl
      }
      return icon
    },
    title () {
      let title = null
      if (this.page) {
        title = getTextValue(this.page.title)
      }
      return title
    },
  },
  created () {
    this.$store.dispatch('pages/getOpeningHours', { startDate: moment().format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD') }).then(() => {
    }).finally(() => {
      this.loading = false
    })
  },
  components: {
    UpcomingEventSummary: () => import('@/components/view-components/webapp-pages/upcoming-events/UpcomingEventSummary.vue'),
  },
}
</script>

<style lang="scss">

</style>